import React from 'react'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import "./feedback.styles.css"
import Quote from '../../assets/faq_quote.svg'

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 450 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 450, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
}

export default function Feedback() {
  return (
    <div className="feedback-container" id="reviews">
      <text className="feedback-heading">
        <span style={{ color: "#575B67" }}>Happy</span>
        <span>{" "}</span>
        <span style={{ color: "#F8C28F" }}>Patients</span>
      </text>
      <div className="feedback-carousel-container">
        <Carousel responsive={responsive} className="carousel-container">
          <div className="carousel-card">
            <div className="quote-container">
              <img src={Quote} alt="Quote" />
            </div>
            <div className="feedback-text">
              Dr Aashima is a very patient listener and an amazing doctor. She picks up the most intricate details of the history to make her diagnosis. Had the best experience with her.
            </div>
            <div className="feedback-footer">
              <div className="doctor-details">
                <div className="doctor-name">Shelly Mittal</div>
                <div className="doctor-specification">
                  <span>New Delhi{' '}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="carousel-card">
            <div className="quote-container">
              <img src={Quote} alt="Quote" />
            </div>
            <div className="feedback-text">
              One of the sweetest doctor I have come across, she helped with a smooth registration process in the hospital in these COVID times. Highly recommended!
            </div>
            <div className="feedback-footer" style={{ marginTop: "3.5rem" }}>
              <div className="doctor-details">
                <div className="doctor-name">Shweta Sood</div>
                <div className="doctor-specification">
                  <span style={{ textAlign: "left" }}>New Delhi</span>
                </div>
              </div>
            </div>
          </div>
          <div className="carousel-card">
            <div className="quote-container">
              <img src={Quote} alt="Quote" />
            </div>
            <div className="feedback-text">
              Dr. Aashima is empathetic which sadly most of the doctors lack. She listens to the patient, tries to understand their position and prescribes medications/solutions accordingly.
            </div>
            <div className="feedback-footer" style={{ marginTop: "1rem" }}>
              <div className="doctor-details">
                <div className="doctor-name">Arushee Grover</div>
                <div className="doctor-specification">
                  <span style={{ textAlign: "left" }}>New Delhi</span>
                </div>
              </div>
            </div>
          </div>
          <div className="carousel-card">
            <div className="quote-container">
              <img src={Quote} alt="Quote" />
            </div>
            <div className="feedback-text">
              She also did not hesitate to spend time with me to explain the reasons for the problem and was able to recommend a remedy for another ailment plaguing me for years.
            </div>
            <div className="feedback-footer">
              <div className="doctor-details">
                <div className="doctor-name">Vinay Nath</div>
                <div className="doctor-specification">
                  <span style={{ textAlign: "left" }}>New Delhi</span>
                </div>
              </div>
            </div>
          </div>
        </Carousel>
      </div>
    </div>
  )
}
